module.exports = __webpack_public_path__ + "media/components/assets/phone_icon-10cbfdb33ff3ebbc7a47002bffdaec6f.svg";